const CartFeature = () => import(/* webpackChunkName: "dist/js/features-cart" */ './CartFeature.vue');
const CartPage = () => import(/* webpackChunkName: "dist/js/features-cart" */ '@resources/scripts/features/cart/CartPage.vue');
const ServicesPage = () => import(/* webpackChunkName: "dist/js/features-cart" */ '@resources/scripts/features/cart/ServicesPage.vue');
const routes = [
    {
        path: '/:studioSlug/cart',
        component: CartFeature,
        children: [
            {
                path: 'home',
                name: 'cart',
                alias: '/:studioSlug/cart',
                meta: { title: 'Your Cart' },
                component: CartPage,
            },
            {
                path: 'services',
                alias: '/:studioSlug/services',
                meta: { title: 'Services' },
                component: ServicesPage,
            },
        ],
    },
];
export default routes;
